export const CREATE_ORDER_USE_FEE_TYPE_STORAGE_KEY = 'createOrderUseFeeType'
export const HAS_PACK_FOOD_STORAGE_KEY = 'hasPackFood'
